import { Injectable, signal, computed, inject, effect } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class LoadingStateService{

  showLoadingPage = signal(false);
  
}
